<template>
  <div class="main-app-shell">
    <MainSidebar
      :stats="stats"
      :offline="offline"
      :collapsed="sidebarCollapsed"
      @toggle-collapse="toggleSidebar"
      @logout="logoutWeb"
    />
    <main
      class="main-app-content"
      :class="{ 'main-app-content--sidebar-collapsed': sidebarCollapsed }"
    >
      <slot />
    </main>
  </div>
</template>

<script>
import MainSidebar from "@/components/MainSidebar.vue";
import CASP from "@/CASP";
import { useCookies } from "vue3-cookies";

const SIDEBAR_STORAGE_KEY = "casp.main.sidebarCollapsed";

export default {
  name: "MainLayout",
  components: { MainSidebar },
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  data() {
    return {
      stats: {},
      offline: false,
      sidebarCollapsed: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      try {
        localStorage.setItem(SIDEBAR_STORAGE_KEY, String(this.sidebarCollapsed));
      } catch (_error) {
        // Browser storage can be unavailable in private browsing contexts.
      }
    },
    logoutWeb() {
      if (this.stats.impersonating) {
        const token = this.cookies.get("caspauth") || this.cookies.get("authtoken");
        CASP.stopImpersonation(token, (status) => {
          if (status === 200) {
            if (localStorage) localStorage.removeItem("stats");
            window.location = "/admin/employees";
          } else {
            alert("Die Admin-Identität konnte nicht wiederhergestellt werden.");
          }
        });
        return;
      }
      CASP.logoutWeb((status) => {
        if (status === 200) {
          this.cookies.remove("caspauth");
          this.cookies.remove("authtoken");
          if (localStorage) localStorage.removeItem("stats");
          window.location = "/forbidden";
        } else if (status === 409) {
          this.loadStats();
          alert("Die Sitzung wird als Admin verwendet. Bitte erneut versuchen.");
        } else {
          alert("Das Ausloggen ist fehlgeschlagen.");
        }
      });
    },
    loadStats() {
      CASP.getStats((status, response) => {
        if (status === 401) {
          window.location = "/forbidden";
        } else if (status === 200) {
          this.offline = false;
          this.stats = response;
          if (this.stats.type === "external") {
            window.location = "/admin";
          }
        } else if (localStorage && localStorage.getItem("stats")) {
          this.stats = JSON.parse(localStorage.getItem("stats"));
          this.offline = true;
        } else {
          window.location = "/forbidden";
        }
      });
    },
  },
  created() {
    try {
      this.sidebarCollapsed =
        localStorage.getItem(SIDEBAR_STORAGE_KEY) === "true";
    } catch (_error) {
      this.sidebarCollapsed = false;
    }
    this.loadStats();
  },
};
</script>

<style scoped>
.main-app-shell {
  height: 100%;
  min-height: 100%;
}

.main-app-content {
  height: 100%;
}

@media (min-width: 768px) {
  .main-app-content {
    width: calc(100% - 300px);
    margin-left: 300px;
  }

  .main-app-content--sidebar-collapsed {
    width: calc(100% - 72px);
    margin-left: 72px;
  }
}
</style>
